module.exports = __webpack_public_path__ + "static/media/M009-noprivilege.fbbd297b.svg";